export enum CalendarTypeEnum {
  Personal,
  Professional
}